export enum UserStatusHistoryEnum {
  Blocked = 'blocked',
  Unlocked = 'unlocked'
}
